import { Uuid } from "./uuid.type";


export class StringUuid implements Uuid {
  static uuidLength = 36;

  readonly uuid: string;
  constructor(uuid: string) {
    if (!uuid) {
      throw new Error('UUID cannot be null or undefined');
    }
    if (uuid.length !== StringUuid.uuidLength) {
      throw new Error('UUID must be 36 characters long');
    }
    this.uuid = uuid;
  }

  asString(): string {
    return this.uuid;
  }

  static isValid(uuid: string): boolean {
    return uuid !== undefined && uuid.length === this.uuidLength;
  }
}
